/* Scoped movement and educational controls. Content is visible without JavaScript. */
(() => {
  'use strict';
  if (window.hfExperienceInitialized) return;
  window.hfExperienceInitialized = true;
  const desktopMotion = window.matchMedia('(min-width: 768px) and (prefers-reduced-motion: no-preference)');
  let layers = [];
  let frame = 0;
  const clamp = (value, limit) => Math.max(-limit, Math.min(limit, value));
  function draw() {
    frame = 0;
    const viewport = window.innerHeight;
    layers.forEach(({ image, container, family }) => {
      if (!desktopMotion.matches) { image.style.removeProperty('--hf-parallax-y'); return; }
      const rect = container.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > viewport + 100) return;
      const limit = rect.height * (family ? 0.043 : 0.082);
      const distance = viewport / 2 - (rect.top + rect.height / 2);
      image.style.setProperty('--hf-parallax-y', clamp(distance * (family ? 0.08 : 0.18), limit).toFixed(2) + 'px');
    });
  }
  function schedule() { if (!frame) frame = window.requestAnimationFrame(draw); }
  function activate(cycle, index) {
    cycle.querySelectorAll('[data-hf-phase]').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.hfPhase) === index));
    });
    cycle.querySelectorAll('[data-hf-panel]').forEach(panel => {
      panel.hidden = Number(panel.dataset.hfPanel) !== index;
    });
  }
  function refresh() {
    layers.forEach(({image}) => image.style.removeProperty('--hf-parallax-y'));
    layers = Array.from(document.querySelectorAll('[data-hf-parallax-container]')).map(container => ({
      container,
      image: container.querySelector('.hf-parallax-image'),
      family: container.classList.contains('hf-brand-media')
    })).filter(layer => layer.image);
    document.querySelectorAll('[data-hf-cycle]').forEach(cycle => {
      if (cycle.dataset.hfInitialized) return;
      cycle.dataset.hfInitialized = 'true';
      activate(cycle, 0);
      cycle.addEventListener('click', event => {
        const button = event.target.closest('[data-hf-phase]');
        if (button && cycle.contains(button)) activate(cycle, Number(button.dataset.hfPhase));
      });
      cycle.addEventListener('keydown', event => {
        const button = event.target.closest('[data-hf-phase]');
        if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...cycle.querySelectorAll('[data-hf-phase]')];
        let index = buttons.indexOf(button);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        activate(cycle, index); buttons[index].focus();
      });
    });
    schedule();
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  desktopMotion.addEventListener('change', schedule);
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-hf-panel]');
    const cycle = panel && panel.closest('[data-hf-cycle]');
    if (cycle) activate(cycle, Number(panel.dataset.hfPanel));
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  refresh();
})();
